<template>
  <div class="root">
    <div v-if="countPipelines" class="pipeline-head">
      <button @click="hidden = !hidden" class="pipeline-button">
        <img v-if="hidden" src="../../files/plus-icon.svg" alt="plus-icon" />
        <img v-else src="../../files/minus-icon.svg" alt="minus-icon" />
      </button>
      <p v-if="countPipelines" class="pipeline-head-title">Трубопроводы ({{ countPipelines }})</p>
      <img v-if="isErrors" src="../../files/alert-icon.svg" alt="alert icon" />
    </div>

    <ul
      :class="[
        'pipeline-list',
        {
          'pipeline-list_hidden': hidden,
        },
      ]"
      v-if="pipelines && pipelines.length > 0"
    >
      <li class="pipeline-list-item" :key="pipeline.id" v-for="(pipeline, pipelineIndex) in pipelines">
        <div class="pipeline-item">
          <div class="pipeline-item-icon-block">
            <div @click.prevent="toggleObjectShow(pipeline.id)" class="pipeline-icon-wrapper">
              <img
                draggable="false"
                :src="getPipelineImage(pipeline.obj_type)"
                :class="[
                  'pipeline-icon-image',
                  {
                    'pipeline-icon_disabled': pipeline.exclude && parseInt(pipeline.exclude) != 0,
                  },
                ]"
              />
              <!-- Иконка исключенного из расчета -->
              <img
                src="../../assets/icons/disabled-icon.svg"
                v-if="pipeline.exclude && parseInt(pipeline.exclude) != 0"
                class="pipeline-exclude-icon"
              />
            </div>

            <div class="pipeline-badge">
              <p v-if="lvgCodes.includes(parseInt(pipeline.obj_type))" class="pipeline-badge-text">ЛВЖ/ГЖ</p>
              <p v-if="sugCodes.includes(parseInt(pipeline.obj_type))" class="pipeline-badge-text">СУГ/СПГ</p>
              <p v-if="gasCodes.includes(parseInt(pipeline.obj_type))" class="pipeline-badge-text">ГАЗ</p>
            </div>
          </div>
          <div class="pipeline-item-name">
            <span :style="{ 'background-color': pipeline.color }" class="submenu-piplene-label" />

            <div class="submenu-piplenes">
              <span class="submenu-map-objects-text black">
                {{ pipeline.name }}
              </span>
              <span class="submenu-map-objects-text"
                >Радиус: <span class="black"> {{ pipeline.R }}</span></span
              >
              <span class="submenu-map-objects-text"
                >Длина: <span class="black"> {{ pipeline.L }}</span></span
              >
            </div>

            <!-- Ошибки установки -->
            <button
              :id="pipeline.id"
              class="pipeline-item-error-button"
              v-if="pipeline.errors"
              @click="showErrors(pipeline.errors)"
            >
              <img src="../../files/alert-icon.svg" alt="alert icon" />
            </button>
            <main-tooltip :target="pipeline.id" tooltipValue="Возникли ошибки" />
          </div>

          <!-- Контекстное меню -->
          <pipeline-dropdown
            :handleDropdownClick="handleDropdownClick"
            :shiftY="shiftY"
            @onFullTurnOff="pipelineTurnOff(pipeline)"
            @onScenarioInformationClick="handlePipelineScenarioInformationClick(pipeline)"
            @onEditClick="handlePipelineEditClick(pipeline)"
            @onRemoveClick="openDeletePipileneModal({ pipelineIndex, id: pipeline.id })"
            @onScenarioConstructorClick="curPipeline = pipeline"
            :pipeline="pipeline"
          />
        </div>
      </li>
    </ul>

    <!-- Модалки -->
    <b-modal id="showPipelineErrors" ref="showPipelineErrors" hide-footer title="Ошибки">
      <span v-if="curErrors">
        <h4 v-if="curErrors.substance">Вещества:</h4>
        <div v-if="curErrors.substance">
          <div :key="subError.substance_id" v-for="subError in curErrors.substance">
            <b-card v-if="subError.substance_name" class="mb-3">
              <h3>
                {{ subError.substance_name
                }}<b-btn
                  variant="success"
                  size="sm"
                  class="pull-right"
                  @click="
                    $refs.showPipelineErrors.hide();
                    $parent.$refs.substances.show();
                    $parent.substanceToShow = { id: subError.substance_id, type: subError.substance_type };
                  "
                  >Перейти</b-btn
                >
              </h3>
              <b-list-group>
                <b-list-group-item v-for="(error, index) in Object.values(subError.errors)" :key="`subError-${index}`"
                  >{{ index + 1 }}. {{ error[0] }}</b-list-group-item
                >
              </b-list-group>
            </b-card>
            <b-card v-else> У одного или нескольких объектов не найдено вещество </b-card>
          </div>
        </div>
        <h4 v-if="curErrors.objects">Оборудование:</h4>
        <div v-if="curErrors.objects">
          <div :key="`obj_error-${objIndex}`" v-for="(obj_error, objIndex) in curErrors.objects">
            <b-card class="mb-3">
              <h3>{{ obj_error.obj_name }}</h3>
              <b-list-group>
                <b-list-group-item v-for="(error, index) in Object.values(obj_error.errors)" :key="`errors-${index}`"
                  >{{ index + 1 }}. {{ error[0] }}</b-list-group-item
                >
              </b-list-group>
            </b-card>
          </div>
        </div>
      </span>
    </b-modal>

    <b-modal size="xl" id="pipelineFactorsData" hide-footer title="Просмотр информации по сценариям">
      <factorsDataPipelines :object="curPipeline" />
    </b-modal>

    <b-modal
      size="xl"
      lazy
      dialog-class="modal-fullscreen-dialog"
      content-class="modal-fullscreen-content"
      id="pipeline-tree"
      hide-footer
      title="Конструктор сценариев"
    >
      <tree :object="curPipeline" @clearCalculations="$emit('clearCalculations')"/>
    </b-modal>

    <!-- Добавить трубопровод -->
    <modal-wrapper
      @onCancelClick="$bvModal.hide('editPipeline')"
      dialogClass="add-social-modal"
      hide-footer
      modalId="editPipeline"
      title="Трубопровод"
    >
      <edit-pipeline
        @pipelineWindowClose="$bvModal.hide('editPipeline')"
        @clearCalculations="$emit('clearCalculations')"
        :substrate="substrate"
        @newObject="objectAdd"
        :pipeline="curPipeline"
        :proj_id="String(project.id)"
        :showErrors="showErrors"
        @onCancelClick="$bvModal.hide('editPipeline')"
      />
    </modal-wrapper>

    <confirm-modal
      ref="pipelineUnconnectedRemoveWindow"
      id="pipelineUnconnectedRemoveWindow"
      title="Удалить"
      content="Вы действительно хотите удалить этот трубопровод?"
      @onSubmitClick="
        pipelineRemove(
          $refs.pipelineUnconnectedRemoveWindow.pipelineIndex,
          $refs.pipelineUnconnectedRemoveWindow.pipelineId
        );
        $bvModal.hide('pipelineUnconnectedRemoveWindow');
      "
    />
  </div>
</template>

<script>
import { getImage, handleInstallationDropdownClick } from "../../utils/utils";
import PipelineDropdown from "./components/PipelineDropdown";
import factorsDataPipelines from "../../views/risks/factorsDataPipelines";
import pipeline from "../../views/risks/pipelines/pipeline";
import MainTooltip from "../ui/MainTooltip";
import ConfirmModal from "../modals/ConfirmModal.vue";
import ModalWrapper from "../modals/ModalWrapper.vue";
import tree from "@/views/risks/tree.vue";

export default {
  props: {
    pipelines: Array,
    project: Object,
    action: String,
    legalIndRisk: Number,
    substrate: Object,
  },
  components: {
    tree,
    PipelineDropdown,
    factorsDataPipelines,
    MainTooltip,
    "edit-pipeline": pipeline,
    ConfirmModal,
    ModalWrapper,
  },
  data() {
    return {
      loading: true,
      curErrors: null,
      curPipeline: {},
      hidden: false,
      openedObjects: [],
      lvgCodes: [41],
      sugCodes: [42],
      gasCodes: [43],
      shiftY: 0,
    };
  },
  computed: {
    countPipelines() {
      return (this.pipelines && this.pipelines.length) || 0;
    },

    isErrors() {
      if (this.pipelines) {
        return this.pipelines.some((item) => item.errors);
      }
      return false;
    },
  },
  methods: {
    handlePipelineScenarioInformationClick(pipeline) {
      this.curPipeline = pipeline;
      this.$bvModal.show("pipelineFactorsData");
    },

    openDeletePipileneModal({ pipelineIndex, id }) {
      this.$refs.pipelineUnconnectedRemoveWindow.pipelineIndex = pipelineIndex;
      this.$refs.pipelineUnconnectedRemoveWindow.pipelineId = id;

      this.$bvModal.show("pipelineUnconnectedRemoveWindow");
    },

    objectAdd(model) {
      this.curPipeline.dots = {};
      if (!this.pipelines) {
        this.$emit("update:pipelines", [model]);
      } else {
        this.pipelines.unshift(model);
      }
      this.$emit("clearCalculations");
      if (model.errors) {
        this.$bvModal.hide("editPipeline");
        this.showErrors(model.errors);
        return;
      }
      this.$bvModal.hide("editPipeline");
    },

    handlePipelineEditClick(pipeline) {
      this.curPipeline = pipeline;
      this.$bvModal.show("editPipeline");
    },

    toggleObjectShow(id) {
      if (this.openedObjects.includes(id)) {
        this.openedObjects = this.openedObjects.filter((item) => item !== id);
      } else {
        this.openedObjects.push(id);
      }
    },

    getPipelineImage(type) {
      return getImage(parseInt(type));
    },

    showErrors(errors) {
      this.curErrors = errors;
      this.$refs.showPipelineErrors.show();
    },

    handleDropdownClick(event) {
      this.shiftY = handleInstallationDropdownClick(event);
    },

    pipelineTurnOff(pipeline) {
      this.$http
        .post("risk/objects/pipeline-exclude?proj_id=" + this.project.id + "&pipeline_id=" + pipeline.id)
        .then((response) => {
          pipeline.exclude = response.data;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },

    pipelineRemove(pipelineIndex, pipeline_id) {
      this.$http
        .post("risk/objects/pipeline-remove?proj_id=" + this.project.id + "&id=" + pipeline_id)
        .then(() => {
          this.pipelines.splice(pipelineIndex, 1);
        })
        .catch((e) => {
          console.error(e);
        });
    },
    makeToast(content, title, variant = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        solid: true,
      });
    },

    newPipeline(data) {
      this.curPipeline = data;
      this.curPipeline.isNewRecord = true;
      this.$bvModal.show("editPipeline");
    },
  },
  watch: {
    pipelines() {
      if (!this.openedObjects.length && this.pipelines) {
        this.pipelines.forEach((item) => {
          if (item.mapObjects && item.mapObjects.length) {
            item.mapObjects.forEach((object) => {
              this.openedObjects.push(object.id);
            });
          }
          this.openedObjects.push(item.id);
        });
      }
    },
  },
};
</script>

<style scoped>
.root {
  margin-top: 16px;
}
.pipeline-head {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pipeline-button {
  border: none;
  padding: 0;
  background: transparent;
}
.pipeline-list-item {
  position: relative;
  margin-bottom: 8px;
}
.pipeline-head-title {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--black-color);
  margin: 0;
}
.pipeline-item-icon-block {
  position: relative;
  z-index: 1;
}
.pipeline-icon-wrapper {
  position: relative;
  width: max-content;
}
.pipeline-icon-image {
  display: block;
  width: 32px;
  height: 32px;
  object-fit: cover;
}
.pipeline-exclude-icon {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.pipeline-badge {
  min-width: 35px;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: -2px;
  padding: 0px 4px;
  border-radius: 20px;
  background: var(--additional-color);
  pointer-events: none;
}
.pipeline-badge-text {
  margin: 0;
  color: var(--white-color);
  font-size: 6px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 10px;
}
.pipeline-item {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pipeline-item-error-button {
  background: transparent;
  border: none;
}
.pipeline-item-name {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  font-size: 12px;
  color: var(--black-color);
  margin: 0;
  flex-grow: 1;
  display: flex;
}
.pipeline-list {
  margin-top: 8px;
  padding-left: 16px;
  max-height: 100%;
  overflow: auto;
}

.pipeline-list_hidden {
  max-height: 0;
  overflow: hidden;
}

.submenu-map-objects {
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 0;
  overflow: hidden;
}
.submenu-map-objects_opened {
  max-height: 1000px;
  padding-top: 7px;
}

.submenu-map-objects-text {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  color: var(--grey-3-color);
  margin-left: 4px;
  flex-grow: 1;
}

.submenu-piplenes {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.submenu-piplene-label {
  position: absolute;
  display: inline-block;
  min-width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 4px;
  top: 8px;
  left: 21px;
  z-index: 2;
}

.pipeline-icon_disabled {
  opacity: 0.5;
}
</style>
